import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { RewardsWalletService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';
import { RoutingHistoryService } from 'src/app/shared/services/routing-history.service';

@Component({
  selector: 'fgb-marketplace-wallet-page',
  templateUrl: './marketplace-wallet-page.component.html',
  styleUrl: './marketplace-wallet-page.component.scss',
})
export class MarketplaceWalletPageComponent implements OnInit, AfterViewInit {
  @Input() id: string;
  mobileTitle: string = 'wallet.page.title';

  constructor(
    private location: Location,
    private rewardWalletService: RewardsWalletService,
    private cd: ChangeDetectorRef,
    private routeHistory: RoutingHistoryService
  ) {}

  ngOnInit(): void {
    firstValueFrom(this.rewardWalletService.fetchWalletItems());
  }
  ngAfterViewInit(): void {
    this._getMobileTitle(this.routeHistory.getPreviousUrl() || '');
  }
  private _getMobileTitle(prevUrl: string): void {
    if (prevUrl.includes('claimed')) {
      this.mobileTitle = 'wallet.redeemed.title';
    }
    this.cd.detectChanges();
  }

  back(): void {
    this.location.back();
  }
}
